import { __assign, __awaiter, __generator } from "tslib";
import LruCache from 'lru-cache';
import Vue from 'vue';
import { ref } from '@nuxtjs/composition-api';
function unproxify(val) {
    if (val instanceof Array) {
        // @ts-ignore
        return val.map(unproxify);
    }
    if (val instanceof Object) {
        // @ts-ignore
        return Object.fromEntries(Object.entries(Object.assign({}, val))
            .map(function (_a) {
            var k = _a[0], v = _a[1];
            return [k, unproxify(v)];
        }));
    }
    return val;
}
var _useLruCache = function () {
    return {
        /**
         * @var Array<LRUCache>
         */
        cacheContainers: {},
        defaultOptions: {},
        setDefaultOptions: function (options) {
            Object.assign(this.defaultOptions, options);
        },
        init: function (name, options) {
            if (name in this.cacheContainers) {
                return;
            }
            if (!options) {
                options = {};
            }
            this.cacheContainers[name] = new LruCache(__assign(__assign({}, this.defaultOptions), options));
        },
        get: function (name) {
            this.init(name);
            return this.cacheContainers[name];
        },
        getContainerNames: function () {
            return Object.keys(this.cacheContainers);
        },
        unproxify: unproxify,
        decorateComposable: function (containerName, cacheKey, composable, dynamicMap, dynamicExpose, passThruFuncs) {
            var _this = this;
            if (passThruFuncs === void 0) { passThruFuncs = []; }
            var useComposable = (typeof composable) === 'function' ? composable() : composable;
            var onNonCachedResult = function (cache, cacheKey) {
                if (!dynamicMap) {
                    return useComposable;
                }
                var retVal = {};
                var cacheValue = {};
                if (dynamicMap) {
                    Object.keys(dynamicMap).forEach(function (key) {
                        var destination = dynamicMap[key];
                        retVal[destination] = ref({});
                        retVal[key] = function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, useComposable[key]()];
                                    case 1:
                                        _a.sent();
                                        retVal[destination].value = useComposable[destination].value;
                                        cacheValue[destination] = useComposable[destination].value;
                                        cache.set(cacheKey, cacheValue);
                                        return [2 /*return*/, Promise.resolve()];
                                }
                            });
                        }); };
                    });
                }
                return onCachedResult(Object.assign({}, retVal, cacheValue));
            };
            var onCachedResult = function (cachedResult) {
                var retVal = {};
                if (passThruFuncs && passThruFuncs.length) {
                    passThruFuncs.forEach(function (key) {
                        retVal[key] = useComposable[key];
                    });
                }
                Object.keys(cachedResult).forEach(function (key) {
                    var _a, _b;
                    retVal[key] = (typeof cachedResult[key] === 'function' ||
                        (typeof cachedResult[key] === 'object' && ((_b = (_a = cachedResult[key]) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name) === 'RefImpl'))
                        ? cachedResult[key]
                        : ref(cachedResult[key]);
                });
                if (dynamicExpose) {
                    dynamicExpose.forEach(function (key) {
                        retVal[key] = key in retVal
                            ? retVal[key]
                            : (typeof useComposable[key] === 'function' ? function () { return Promise.resolve(); } : useComposable[key]);
                    });
                }
                return retVal;
            };
            return this.execute(containerName, cacheKey, onCachedResult, onNonCachedResult);
        },
        execute: function (containerName, cacheKey, onCachedResult, onNonCachedResult, booleanCheckOnResult) {
            return __awaiter(this, void 0, void 0, function () {
                var cache, cachedResult, returnResult;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            cache = this.get(containerName);
                            cachedResult = cache.get(cacheKey);
                            returnResult = !!cachedResult;
                            if (returnResult && !!booleanCheckOnResult) {
                                returnResult = booleanCheckOnResult(cachedResult);
                            }
                            if (returnResult) {
                                return [2 /*return*/, onCachedResult(cachedResult)];
                            }
                            return [4 /*yield*/, onNonCachedResult(cache, cacheKey)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        }
    };
};
var getInstance;
// eslint-disable-next-line no-prototype-builtins
if (!Vue.prototype.hasOwnProperty('$vmoCacheContainers')) {
    getInstance = _useLruCache();
    Object.defineProperty(Vue.prototype, '$vmoCacheContainers', {
        get: function () { return getInstance; }
    });
}
else {
    getInstance = Vue.prototype.$vmoCacheContainers;
}
export default (function () { return getInstance; });
//# sourceMappingURL=useLruCache.js.map